import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./app";
import "src/services/i18n";
import { init as initFS } from "./utils/tracking/fullstory";
import { init as initH } from "./utils/tracking/highlight";

initH();
initFS();

const container = document.getElementById("root");

const root = createRoot(container!);

root.render(
    <React.StrictMode>
        <React.Suspense fallback={null}>
            <App />
        </React.Suspense>
    </React.StrictMode>
);
